import request from '@/utils/request'

/**
 * 财务管理 - 充值手动上账审核
 * 接口路径：/api/order/tuitionOrder/teev2
 */
const apiPath = '/order/tuitionOrder/teev2'

const rechargeManualLedgerAuditApi = {
  /**
   * 分页查询【充值手动上账审核】列表
   * GET /api/order/tuitionOrder/teev2/listFinance
   * 请求类型：application/x-www-form-urlencoded
   */
  fetchList(query) {
    return request.get(apiPath + '/listFinance', { params: query })
  },

  /**
   * 分页查询【充值记录】列表
   * GET /api/order/tuitionOrder/teev2/list
   * 请求类型：application/x-www-form-urlencoded
   */
  fetchRecordList(query) {
    return request.get(apiPath + '/list', { params: query })
  },

  /**
   * 同意申请
   * POST /api/order/tuitionOrder/teev2/audit
   * 请求类型：application/json
   * auditStatus: 10 (已同意)
   */
  approve(data) {
    return request.post(apiPath + '/audit', {
      id: data.id,
      auditStatus: 10,
      auditRemark: data.auditRemark || ''
    })
  },

  /**
   * 驳回申请
   * POST /api/order/tuitionOrder/teev2/audit
   * 请求类型：application/json
   * auditStatus: 20 (已驳回)
   */
  reject(data) {
    return request.post(apiPath + '/audit', {
      id: data.id,
      auditStatus: 20,
      auditRemark: data.reason || data.auditRemark || ''
    })
  },

  /**
   * 创建导出任务（异步导出，跳转导出页面使用）
   * GET /api/order/tuitionOrder/teev2/export
   * 请求类型：application/x-www-form-urlencoded
   */
  createExportTask(data) {
    return request.get(apiPath + '/export', { params: data })
  }
}

export default rechargeManualLedgerAuditApi
